// @ts-generator-hash: 66b9d2d231afaa079cb207bbe84d0bdf654780767f726488ffbbe970a84de595
// Generation date: 5/4/2026 2:29:49 PM
// Auto-generated by CSharpToTypeScriptConverter
// Based on type: C06Camera.DL.Helpers.UserRole
export enum UserRole {
  ORF_DTR = 0,
  PI = 1,
  PO = 2,
  SO = 3,
  GMS = 4,
  ORF_DEP = 5,
  PO_SUPERVISOR = 10,
  GMS_SUPERVISOR = 11,
  ORF_DTR_SUPERVISOR = 12,
  EXTERNAL_USER = 100,
  EXTERNAL_REVIEWER = 103,
  EXTERNAL_AE_DESIGNER = 104,
  EXTERNAL_PROJECT_MANAGER = 105,
  SU = 999,
}
